import React from "react";

import "./style.css";

// components
import OrdersReport from "./components/OrdersReport";

const Reports = () => {
    return (
        <>
            <div className="product-panel-title mb-4">
                <h3>Reports</h3>
            </div>
            <div className="bg-white border border-solid border-ec-table-stock rounded-xl p-6 min-h-screen">
                <OrdersReport />
            </div>
        </>
    );
};

export default Reports;
